import React from "react";
import Typography from "@material-ui/core/Typography";
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';

const WelcomeMessage = () => {
    const { authStore } = useSelector((state: RootState) => state);
    let lastLogin = authStore?.data?.lastLogin;
    try {
        if (lastLogin?.split(" ")[0].split("-")[2].length === 4) {
            lastLogin = `${lastLogin.split(" ")[0].split("-").reverse().join("-")} ${lastLogin.split(" ")[1]}`
        }
    } catch (err) {
        console.log(err);
    }

    return (
        <div className="welcomemsg">
            <Typography style={{ fontWeight: 'bold', color: '#FFF' }}>Welcome {authStore?.data?.givenName}!</Typography>
            {!isNaN(new Date(lastLogin || 0).getTime()) && <Typography style={{ color: '#FFF', fontWeight: 400 }} >Last login {formatDistanceToNowStrict(new Date(lastLogin || 0))} ago</Typography>}
        </div>
    );
};
export default WelcomeMessage;